import { render, staticRenderFns } from "./LffMentions.vue?vue&type=template&id=dbb4f6b6&scoped=true&"
import script from "./LffMentions.vue?vue&type=script&lang=js&"
export * from "./LffMentions.vue?vue&type=script&lang=js&"
import style0 from "./LffMentions.vue?vue&type=style&index=0&id=dbb4f6b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb4f6b6",
  null
  
)

export default component.exports